module.exports = __webpack_public_path__ + "img/down_app_content.220860d3.png";